import styled, { css } from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: center;
`;

export const ProfileInfo = styled.div`
  margin-left: 30px;
  color: #fff;
  font-size: 15px;
  flex-grow: 1;
  div {
    display: flex;
    align-items: center;
  }
`;

export const Name = styled.p`
  font-size: 26px;
  margin-bottom: 15px;
`;
export const Type = styled.p`
  font-size: 15px;
  margin-bottom: 15px;
`;

export const AccountLink = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
`;

export const Right = styled.div`
  text-align: right;
`;

export const Amount = styled.p`
  font-size: 20px;
  margin-right: 30px;
`;
